import React from 'react';

import styles from "./paramsBlock.module.scss"

const ParamsBlock = (props) => {
  const { title, helpText, value } = props

  return (
    <div className={styles.paramBlock}>
      <div className={styles.titleBlock}>
        <span className={styles.title}>{title}</span>
        <span className={styles.helpText}>{helpText}</span>
      </div>
      <div className={styles.contentBlock}>
        <span className={styles.value}>{value}</span>

        {props.children}
      </div>
    </div>
  )
}

export default ParamsBlock;